import { Button, Dialog } from '@spiaggeit/spit-ui'
import { Dispatch, ReactElement, SetStateAction } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { ExternalLink } from '@/components/ExternalLink'
import { useAppSelector } from '@/hooks/store.ts'
import { appSlice } from '@/store/appSlice'
import { getInsurancePdfPaths } from '@/utils/getInsurancePdfPaths'

interface InsuranceDialogProps {
  isDialogOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  onSelectInsurance(): void
  trigger: ReactElement
}

export const InsuranceDialog = (props: InsuranceDialogProps) => {
  const { t, i18n } = useTranslation()
  const isPool = useAppSelector(appSlice.selectors.isPool)
  const { informationSetPdfPath, privacyPdfPath } = getInsurancePdfPaths(
    i18n.language
  )

  return (
    <Dialog
      isOpen={props.isDialogOpen}
      mobileMode="bottomSheet"
      setIsOpen={props.setIsOpen}
      size="sm"
      title={t('extra.weatherInsurance.title')}
      trigger={props.trigger}
    >
      <div className="flex flex-col gap-4 border-t border-t-gray-100 p-4 text-xs text-secondary">
        <p>{t('extra.weatherInsurance.consentText')}</p>

        <p className="underline">
          {t('extra.weatherInsurance.consentTextPrice', {
            context: isPool ? 'pool' : 'beach',
          })}
        </p>

        <p>
          <Trans
            components={[
              <ExternalLink
                href={informationSetPdfPath}
                isInsideParagraph
                key="information-set-link"
                target="_blank"
              />,
              <ExternalLink
                href={privacyPdfPath}
                isInsideParagraph
                key="privacy-link"
                target="_blank"
              />,
            ]}
            i18nKey="extra.weatherInsurance.consentTextInfoMaterial"
          />
        </p>

        <Button onClick={props.onSelectInsurance}>
          {t('extra.addGoodWeatherGuarantee')}
        </Button>
      </div>
    </Dialog>
  )
}
